var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-layout',{attrs:{"wrap":"","row":"","ma-0":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Tag Name"},model:{value:(_vm.appliedfilter.name),callback:function ($$v) {_vm.$set(_vm.appliedfilter, "name", $$v)},expression:"appliedfilter.name"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }